import { useDiscordUser } from "../../../utils/hooks/useDiscordUser";
import { Trans } from "@lingui/react/macro";
import { VStack, Text } from "@wootingkb/component-library";

export function Rewards() {
  const { user } = useDiscordUser();
  if (!user || user.rewarded.length === 0) return <></>;

  return (
    <VStack className="gap-2">
      <Text weight="semibold">
        <Trans id="Discord_your_rewards_title">Your Rewards</Trans>
      </Text>
      <ul className="list-inside list-disc pl-4">
        {user.rewarded.map((reward) => (
          <li key={reward.roleId}>
            <Text>{reward.rewardName}</Text>
          </li>
        ))}
      </ul>
    </VStack>
  );
}
